<template>
    <div class="Navigation">
        <div v-if="title" class="Navigation__title">
            {{ title }}
        </div>
        <div class="Navigation__index">
            <span>{{ currentPosition || 0 }}</span>
            <span>of</span>
            <span>{{ maxPosition || 0 }}</span>
        </div>
        <NewButton
            variant="flat"
            color="neutral"
            size="icon-sm"
            class="Navigation__prev"
            :disabled="currentPosition <= 1"
            aria-label="Previous"
            @click="navigatePrevious"
        >
            <FontAwesomeIcon :icon="faAngleLeft" />
        </NewButton>
        <NewButton
            variant="flat"
            color="neutral"
            size="icon-sm"
            class="Navigation__next"
            :disabled="currentPosition === maxPosition"
            aria-label="Next"
            @click="navigateNext"
        >
            <FontAwesomeIcon :icon="faAngleRight" />
        </NewButton>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { faAngleLeft, faAngleRight } from '@fortawesome/pro-light-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import NewButton from '@/components/new-button/NewButton.vue';

    @Component({
        emits: [ 'next', 'previous' ],
        components: { FontAwesomeIcon, NewButton },
    })
    export default class Navigation extends Vue {
        @Prop({ type: String, default: '' })
        private title!: string;

        @Prop({ type: Number, default: 0 })
        private currentPosition!: number;

        @Prop({ type: Number, default: 0 })
        private maxPosition!: number;

        private faAngleLeft = faAngleLeft;
        private faAngleRight = faAngleRight;

        private navigatePrevious(): void {
            if (this.currentPosition > 1) {
                this.$emit('previous');
            }
        }

        private navigateNext(): void {
            if (this.currentPosition < this.maxPosition) {
                this.$emit('next');
            }
        }
    }
</script>
